import { CustomAffichage, ProprieteAffichee, TypePropriete } from './proprieteAffichee';

export class Orthophoto {
  id:number;
  guidProcess: string;
  siteId:number;
  name: string;
  creationDate: Date;
  isActif: boolean;
  ordre: number;
  thumbnailUrl:string;

  constructor(name = '', guidProcess = ''){
    this.name = name;
    this.guidProcess = guidProcess;
  }

  getProprietesAffichees() {
    let tab: ProprieteAffichee[] = [];
    tab.push(new ProprieteAffichee('nom', 'GLOBAL.NOM'));
    tab.push(new ProprieteAffichee('Creation date', 'GLOBAL.DATE_CREATION'));
    tab.push(new ProprieteAffichee('delete', 'GLOBAL.SUPPRIMER'));
    tab.push(new ProprieteAffichee('isActif', 'GLOBAL.ACTIF', '',
      new CustomAffichage(TypePropriete.Boolean, 'fas fa-check-circle checkbox-epc-green', 'fas fa-minus-circle checkbox-epc-red')));
    
    tab.push(new ProprieteAffichee('ordre', 'GLOBAL.ORDRE', '', new CustomAffichage(TypePropriete.Number)));
    return tab;
  }
}

export class OrthoPhotoDto{
  public id: number;
  public tileSetId:string;
  public mapName:string;
  public isVisible: boolean;
  public zOrder: number;
  public creationDate: Date;

  public bounds: number[];
  public center: number[];
  public tiles: string;
}
export interface OrthoLayer {
  id: string;
  name: string;
  date: Date;
  visible: boolean;
  previewUrl?: string;
}
